import { ExpressionConfiguration } from "../../rule-engine-core/Expressions/ExpressionConfiguration";
import { ExpressionView, ExpressionViewEmptyBehavior } from "../../Expressions/ExpressionView";

export interface IExpressionEditorValueFirst {
    expression: ExpressionConfiguration;
    onUpdate: (val: ExpressionConfiguration) => void;
    hideValidation?: boolean;
    open?: boolean;
    onClose?: () => void;
}

export const ExpressionEditorValueFirst = ({
    expression,
    onUpdate,
    hideValidation,
    open,
}: IExpressionEditorValueFirst) => {
    return (
        <ExpressionView
            expression={expression}
            open={open}
            onUpdate={() => onUpdate(expression)}
            hideValidation={hideValidation}
            emptyBehavior={ExpressionViewEmptyBehavior.VALUE}
        />
    );
};
